export const SITE_URL = 'https://www.reachperformancehq.com'

export const BUSINESS = {
  name: 'Reach Performance',
  legalName: 'Reach Performance LLC',
  venue: 'INPOWERiQ Performance Center',
  street: '6051 Alma Rd',
  city: 'McKinney',
  state: 'TX',
  zip: '75070',
  phoneDisplay: '(708) 980-4666',
  phoneHref: 'tel:+17089804666',
  smsHref: 'sms:+17089804666',
  email: 'Fernando@reachperformancehq.com',
  instagram: 'https://instagram.com/reachperformancehq',
  mapsUrl: 'https://maps.google.com/?q=6051+Alma+Rd,+McKinney,+TX+75070',
  areaServed: ['McKinney', 'Frisco', 'Allen', 'Prosper', 'Plano'],
} as const

export const SEASON = {
  label: 'Fall 2026',
  startLong: 'Tuesday, September 1',
  start: 'September 1',
  end: 'December 17',
  endLong: 'Thursday, December 17',
  range: 'September 1 to December 17',
} as const

export const ANNOUNCEMENT =
  'Fall enrollment open · Starts September 1 · Small groups capped.'
